document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.hk-contact-form').forEach(function(form){
    var button=form.querySelector('button[type="submit"]');
    if(!button)return;
    form.addEventListener('submit',function(event){
      if(button.disabled){event.preventDefault();return;}
      if(!form.checkValidity())return;
      button.disabled=true;
      button.setAttribute('aria-disabled','true');
      button.setAttribute('aria-busy','true');
      button.textContent=button.dataset.sendingLabel||'Sending…';
    });
  });
  var success=document.querySelector('.hk-contact-success');
  if(success)success.focus({preventScroll:true});
});
